module.exports = __webpack_public_path__ + "static/media/intereact-logo.57f8ba0b.svg";